import { defineStore } from 'pinia';
import { data } from '@/shared/data';

export const useAttributeStore = defineStore('options', {
  state: () => ({
    attributes: null,
    loading: false,
    error: null,
    _queue: [], // queue of pending promises
  }),

  actions: {
    async getAttributes() {
      // Return immediately if already loaded
      if (this.attributes) return this.attributes;

      // If already loading, return a promise that resolves when done
      if (this.loading) {
        return new Promise((resolve, reject) => {
          this._queue.push({ resolve, reject });
        });
      }

      this.loading = true;
      this.error = null;

      try {
        const items = await data.getReplacementStringAttributes();
        this.attributes = [
          ...items.map(item => `%${item.code}%`)
        ].sort();

        // Resolve any queued calls
        this._queue.forEach(({ resolve }) => resolve(this.attributes));
        this._queue = [];

        return this.attributes;
      } catch (err) {
        this.error = err;

        // Reject any queued calls
        this._queue.forEach(({ reject }) => reject(err));
        this._queue = [];

        throw err;
      } finally {
        this.loading = false;
      }
    },

    async refreshAttributes() {
      this.attributes = null;
      return await this.getAttributes();
    },

    clearAttributes() {
      this.attributes = null;
    }
  }
});
